<template>
  <div class="pm__innerOptions">
    <div v-for="(optionValue, index) in group" :key="index">
      <div
        v-if="['Inseam', 'Outseam'].includes(optionName) && additionalPropertyOptions.length"
        :class="[
          'pm__option-item',
          { selected: optionValue.value === selectedOptions[optionName] },
          { 'is--number-type': isNumber(optionValue.value) },
        ]"
      >
        <a
          :href="seamHandle(optionValue.value, selectedOptions[optionName])"
          class="pm__option-item-name"
          :aria-label="`option ${optionValue.value} for ${optionName}`"
        >
          {{ optionValue.value }}
        </a>
      </div>

      <button
        v-else
        :class="[
          'pm__option-item',
          { selected: optionValue.value === selectedOptions[optionName] },
          { 'is--onesize': optionValue.value.toLowerCase() === 'one size' },
          { 'is--number-type': isNumber(optionValue.value) },
        ]"
        data-stio-gtm-id="PDP: Option"
        :data-available="optionValue.available"
        :disabled="hideUnavailableOption ? !optionValue.available : false"
        @click="() => updateSelection(optionName, optionValue.value, optionValue)"
        :aria-disabled="!optionValue.available"
        :aria-pressed="optionValue.value === selectedOptions[optionName]"
        :aria-label="`option: ${optionName} ${getModifiedOptionName(optionName, optionValue.value)}`"
      >
        <span class="pm__option-item-name">{{ getModifiedOptionName(optionName, optionValue.value) }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    group: Array,
    optionName: String,
    selectedOptions: Object,
    hideUnavailableOption: Boolean,
    additionalPropertyOptions: Array,
    updateSelection: Function,
    getModifiedOptionName: Function,
    seamHandle: Function,
  });

  /**
   * Check if the value is a number
   * @param {String} value
   * @returns {Boolean}
   */
  const isNumber = (value) => !isNaN(Number(value));
</script>
